import SettingsRoleAdmin from "../SettingsRoleAdmin/SettingsRoleAdmin";
import SettingsSpaceAdmin from "../SettingsSpaceAdmin/SettingsSpaceAdmin";
import SettingsResourceScheduleAdmin from "../SettingsResourceScheduleAdmin/SettingsResourceScheduleAdmin";
import SettingsPenaltyAdmin from "../SettingsPenaltyAdmin/SettingsPenaltyAdmin";
import SettingsEventSignatureAdmin from "../SettingsEventSignatureAdmin/SettingsEventSignatureAdmin";
import { PERMISSIONS_VIEWS } from "config/userPermissions";

const { CONFIG } = PERMISSIONS_VIEWS;
export const ALLOWED_SETTINGS_MODULES = [
	CONFIG.ADMIN_ROLES,
	CONFIG.ADMIN_ESPACIOS,
	CONFIG.ADMIN_HORARIOS,
	CONFIG.ADMIN_SANCIONES,
	CONFIG.ADMIN_FIRMAS_EVENTOS,
];
export const onlySettingsModules = ({ id }) =>
	ALLOWED_SETTINGS_MODULES.includes(id);
export const SETTINGS_MODULES = [
	{
		id: CONFIG.ADMIN_ROLES,
		path: "roles",
		View: SettingsRoleAdmin
	},
	{
		id: CONFIG.ADMIN_ESPACIOS,
		path: "espacios/*",
		View: SettingsSpaceAdmin
	},
	{
		id: CONFIG.ADMIN_HORARIOS,
		path: "horarios",
		View: SettingsResourceScheduleAdmin,
	},
	{
		id: CONFIG.ADMIN_SANCIONES,
		path: "sanciones",
		View: SettingsPenaltyAdmin
	},
	{
		id: CONFIG.ADMIN_FIRMAS_EVENTOS,
		path: "firmas-eventos",
		View: SettingsEventSignatureAdmin
	},
].filter(onlySettingsModules);
